import {WpProvider} from "./wp-provider.model";
import {Role} from "./role.model";
import {ProviderCounty} from "./ProviderCounty";
import {ProviderOffice} from "./ProviderOffice";
import {User} from "./User";
import {UserRoles} from "./UserRoles";
import {UserInformation} from "./UserInformation";
import {UserOffice} from "./UserOffice";


export class StaffInfo{
  constructor(

    public user?: User,
    public userRoles?: UserRoles[],
    public userInformation?: UserInformation,
    public userOffice?: UserOffice,


/*    public providers?: WpProvider[],
    public roles?: Role[],
    public providerCounties?: ProviderCounty[],
    public providerOffices?: ProviderOffice[],*/





  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/StaffInfo.ts